import { IAppState } from '../app.state';
import { createSelector } from '@ngrx/store';
import { IFormulariosState } from '../reducers/formularios.reducers';

export const selectFormulariosList = createSelector(
    (state: IAppState) => state.formularios,
    (state: IFormulariosState) => state.formularios
);

export const selectFormulariosAsignadosList = createSelector(
    (state: IAppState) => state.formularios,
    (state: IFormulariosState) => state.formulariosAsignados
);

export const selectFormularioResponsesList = createSelector(
    (state: IAppState) => state.formularios,
    (state: IFormulariosState) => state.formularioResponses
);
